tinymce.addI18n("sk", {
    "#": "#",
    "Accessibility": "Dostupnos\u0165",
    "Accordion": "Rozba\u013eovacia sekcia",
    "Accordion body...": "Telo sekcie...",
    "Accordion summary...": "S\xfahrn sekcie...",
    "Action": "\xdakon",
    "Activity": "Aktivity",
    "Address": "Adresa",
    "Advanced": "Pokro\u010dil\xe9",
    "Align": "Zarovna\u0165",
    "Align center": "Zarovna\u0165 na stred",
    "Align left": "Zarovna\u0165 v\u013eavo",
    "Align right": "Zarovna\u0165 vpravo",
    "Alignment": "Zarovnanie",
    "Alignment {0}": "Zarovnanie {0}",
    "All": "V\u0161etko",
    "Alternative description": "Alternat\xedvny popis",
    "Alternative source": "Alternat\xedvny zdroj",
    "Alternative source URL": "Alternat\xedvny zdroj URL",
    "Anchor": "Kotva",
    "Anchor...": "Kotva...",
    "Anchors": "Kotvy",
    "Animals and Nature": "Zvierat\xe1 a pr\xedroda",
    "Arrows": "\u0160\xedpky",
    "B": "M",
    "Background color": "Farba pozadia",
    "Background color {0}": "Farba pozadia {0}",
    "Black": "\u010cierna",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Cit\xe1cia",
    "Blocks": "Bloky",
    "Blue": "Modr\xe1",
    "Blue component": "Modr\xe1 zlo\u017eka",
    "Body": "Telo",
    "Bold": "Tu\u010dn\xe9",
    "Border": "Or\xe1movanie",
    "Border color": "Farba or\xe1movania",
    "Border style": "\u0160t\xfdl okraja",
    "Border width": "\u0160\xedrka okraja",
    "Bottom": "Spodok",
    "Browse files": "Preh\u013ead\xe1va\u0165 s\xfabory",
    "Browse for an image": "N\xe1js\u0165 obr\xe1zok",
    "Browse links": "Preh\u013ead\xe1va\u0165 odkazy",
    "Bullet list": "Zoznam s odr\xe1\u017ekami",
    "Cancel": "Zru\u0161i\u0165",
    "Caption": "Popisok",
    "Cell": "Bunka",
    "Cell padding": "Odsadenie v bunk\xe1ch",
    "Cell properties": "Vlastnosti bunky",
    "Cell spacing": "Rozstup buniek",
    "Cell styles": "\u0160t\xfdly bunky",
    "Cell type": "Typ bunky",
    "Center": "Stred",
    "Characters": "Znaky",
    "Characters (no spaces)": "Znaky (bez medzier)",
    "Circle": "Kruhov\xfd",
    "Class": "Trieda",
    "Clear formatting": "Vymaza\u0165 form\xe1tovanie",
    "Close": "Zatvori\u0165",
    "Code": "K\xf3d",
    "Code sample...": "Vzorka k\xf3du...",
    "Code view": "Zobrazenie k\xf3du",
    "Color Picker": "V\xfdber farieb",
    "Color swatch": "Vzorky farieb",
    "Cols": "St\u013apce",
    "Column": "St\u013apec",
    "Column clipboard actions": "Clipboard akcie nad st\u013apcom",
    "Column group": "Skupina st\u013apcov",
    "Column header": "Hlavi\u010dka st\u013apca",
    "Constrain proportions": "Obmedzenie proporci\xed",
    "Copy": "Kop\xedrova\u0165",
    "Copy column": "Kop\xedrova\u0165 st\u013apec",
    "Copy row": "Kop\xedrova\u0165 riadok",
    "Could not find the specified string.": "Zadan\xfd re\u0165azec sa nena\u0161iel.",
    "Could not load emojis": "Nebolo mo\u017en\xe9 nahra\u0165 emotikony",
    "Count": "Po\u010det",
    "Currency": "Mena",
    "Current window": "Aktu\xe1lne okno",
    "Custom color": "Vlastn\xe1 farba",
    "Custom...": "Vlastn\xe9...",
    "Cut": "Vystrihn\xfa\u0165",
    "Cut column": "Vystrihn\xfa\u0165 st\u013apec",
    "Cut row": "Vystrihn\xfa\u0165 riadok",
    "Dark Blue": "Tmavomodr\xe1",
    "Dark Gray": "Tmavosiv\xe1",
    "Dark Green": "Tmavozelen\xe1",
    "Dark Orange": "Tmavooran\u017eov\xe1",
    "Dark Purple": "Tmavofialov\xe1",
    "Dark Red": "Tmavo\u010derven\xe1",
    "Dark Turquoise": "Tmavotyrkysov\xe1",
    "Dark Yellow": "Tmavo\u017elt\xe1",
    "Dashed": "\u010ciarkovan\xe9",
    "Date/time": "D\xe1tum/\u010das",
    "Decrease indent": "Zmen\u0161i\u0165 odsadenie",
    "Default": "V\xfdchodzie",
    "Delete accordion": "Vymaza\u0165 sekciu",
    "Delete column": "Vymaza\u0165 st\u013apec",
    "Delete row": "Zmaza\u0165 riadok",
    "Delete table": "Zmaza\u0165 tabu\u013eku",
    "Dimensions": "Rozmery",
    "Disc": "Ov\xe1lny",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Bodkovan\xe9",
    "Double": "Dvojit\xe9",
    "Drop an image here": "Pretiahnite obr\xe1zok sem",
    "Dropped file type is not supported": "Vkladan\xfd typ s\xfabora nie je podporovan\xfd",
    "Edit": "Upravi\u0165",
    "Embed": "Vlo\u017ei\u0165",
    "Emojis": "Emotikony",
    "Emojis...": "Emotikony...",
    "Error": "Chyba",
    "Error: Form submit field collision.": "Chyba: konflikt po\u013ea odosielania formul\xe1ra.",
    "Error: No form element found.": "Chyba: nena\u0161iel sa prvok formul\xe1ra.",
    "Extended Latin": "Roz\u0161\xedren\xe1 latinka",
    "Failed to initialize plugin: {0}": "Nepodarilo sa inicializova\u0165 plugin: {0}",
    "Failed to load plugin url: {0}": "Nepodarilo sa nahra\u0165 plugin url: {0}",
    "Failed to load plugin: {0} from url {1}": "Plugin: {0} sa nepodarilo nahra\u0165 z url {1}",
    "Failed to upload image: {0}": "Obr\xe1zok sa nepodarilo nahra\u0165: {0}",
    "File": "S\xfabor",
    "Find": "H\u013eada\u0165",
    "Find (if searchreplace plugin activated)": "N\xe1js\u0165 (ak je aktivovan\xfd plugin vyh\u013ead\xe1vania)",
    "Find and Replace": "N\xe1js\u0165 a nahradi\u0165",
    "Find and replace...": "N\xe1js\u0165 a nahradi\u0165...",
    "Find in selection": "N\xe1js\u0165 vo v\xfdbere",
    "Find whole words only": "H\u013eada\u0165 len cel\xe9 slov\xe1",
    "Flags": "Vlajky",
    "Focus to contextual toolbar": "Zameranie na kontextov\xfd panel s n\xe1strojmi",
    "Focus to element path": "Zameranie na cestu prvku",
    "Focus to menubar": "Zameranie na panel s ponukami",
    "Focus to toolbar": "Zameranie na panel s n\xe1strojmi",
    "Font": "P\xedsmo",
    "Font size {0}": "Ve\u013ekos\u0165 p\xedsma {0}",
    "Font sizes": "Ve\u013ekosti p\xedsma",
    "Font {0}": "Font {0}",
    "Fonts": "Typy p\xedsma",
    "Food and Drink": "Jedlo a n\xe1poje",
    "Footer": "P\xe4ta",
    "Format": "Form\xe1t",
    "Format {0}": "Form\xe1t {0}",
    "Formats": "Form\xe1ty",
    "Fullscreen": "Na cel\xfa obrazovku",
    "G": "Z",
    "General": "Z\xe1kladn\xe9",
    "Gray": "Siv\xe1",
    "Green": "Zelen\xe1",
    "Green component": "Zelen\xe1 zlo\u017eka",
    "Groove": "Vtla\u010den\xfd okraj",
    "Handy Shortcuts": "U\u017eito\u010dn\xe9 odkazy",
    "Header": "Hlavi\u010dka",
    "Header cell": "Bunka z\xe1hlavia",
    "Heading 1": "Nadpis 1",
    "Heading 2": "Nadpis 2",
    "Heading 3": "Nadpis 3",
    "Heading 4": "Nadpis 4",
    "Heading 5": "Nadpis 5",
    "Heading 6": "Nadpis 6",
    "Headings": "Nadpisy",
    "Height": "V\xfd\u0161ka",
    "Help": "Pomocn\xedk",
    "Hex color code": "Hexa k\xf3d farby",
    "Hidden": "Skryt\xe9",
    "Horizontal align": "Horizont\xe1lne zarovnanie",
    "Horizontal line": "Horizont\xe1lna \u010diara",
    "Horizontal space": "Horizont\xe1lny priestor",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID by sa malo za\u010d\xedna\u0165 p\xedsmenom, po ktorom nasleduj\xfa iba p\xedsmen\xe1, \u010d\xedsla, poml\u010dky, bodky, dvojbodky alebo pod\u010diarkovn\xedky.",
    "Image is decorative": "Obr\xe1zok je dekorat\xedvny",
    "Image list": "Zoznam obr\xe1zkov",
    "Image title": "N\xe1zov obr\xe1zka",
    "Image...": "Obr\xe1zok...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP chyba: Nebolo n\xe1jden\xe9 Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP chyba: Chybn\xe1 Image Proxy URL adresa",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP chyba: Odmietnut\xe1 po\u017eiadavka",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP chyba: Nezn\xe1ma ImageProxy chyba",
    "Increase indent": "Zv\xe4\u010d\u0161i\u0165 odsadenie",
    "Inline": "Vlo\u017een\xe9 \u0161t\xfdly",
    "Insert": "Vlo\u017ei\u0165",
    "Insert Template": "Vlo\u017ei\u0165 \u0161abl\xf3nu",
    "Insert accordion": "Prida\u0165 rozba\u013eovaciu sekciu",
    "Insert column after": "Vlo\u017ei\u0165 st\u013apec za",
    "Insert column before": "Vlo\u017ei\u0165 st\u013apec pred",
    "Insert date/time": "Vlo\u017ei\u0165 d\xe1tum/\u010das",
    "Insert image": "Vlo\u017ei\u0165 obr\xe1zok",
    "Insert link (if link plugin activated)": "Vlo\u017ei\u0165 odkaz (ak je aktivovan\xfd plugin odkazu)",
    "Insert row after": "Vlo\u017ei\u0165 riadok za",
    "Insert row before": "Vlo\u017ei\u0165 riadok pred",
    "Insert table": "Vlo\u017ei\u0165 tabu\u013eku",
    "Insert template...": "Vlo\u017ei\u0165 \u0161abl\xf3nu...",
    "Insert video": "Vlo\u017ei\u0165 video",
    "Insert/Edit code sample": "Vlo\u017ei\u0165/upravi\u0165 vzorku k\xf3du",
    "Insert/edit image": "Vlo\u017ei\u0165/upravi\u0165 obr\xe1zok",
    "Insert/edit link": "Vlo\u017ei\u0165/upravi\u0165 odkaz",
    "Insert/edit media": "Vlo\u017ei\u0165/upravi\u0165 m\xe9di\xe1",
    "Insert/edit video": "Vlo\u017ei\u0165/upravi\u0165 video",
    "Inset": "Vtla\u010den\xe9",
    "Invalid hex color code: {0}": "Nespr\xe1vny hex k\xf3d farby: {0}",
    "Invalid input": "Chybn\xfd vstup",
    "Italic": "Kurz\xedva",
    "Justify": "Zarovna\u0165",
    "Keyboard Navigation": "Navig\xe1cia pomocou kl\xe1vesnice",
    "Language": "Jazyk",
    "Learn more...": "Zisti viac...",
    "Left": "V\u013eavo",
    "Left to right": "Z\u013eava doprava",
    "Light Blue": "Svetlomodr\xe1",
    "Light Gray": "Svetlosiv\xe1",
    "Light Green": "Svetlozelen\xe1",
    "Light Purple": "Svetlofialov\xe1",
    "Light Red": "Svetlo\u010derven\xe1",
    "Light Yellow": "Svetlo\u017elt\xe1",
    "Line height": "V\xfd\u0161ka riadku",
    "Link list": "Zoznam odkazov",
    "Link...": "Odkaz...",
    "List Properties": "Vlastnosti Zoznamu",
    "List properties...": "Vlastnosti Zoznamu...",
    "Loading emojis...": "Nahr\xe1vam emotikony...",
    "Loading...": "Nahr\xe1vam...",
    "Lower Alpha": "Mal\xe9 p\xedsmen\xe1",
    "Lower Greek": "Mal\xe9 gr\xe9cke p\xedsmen\xe1",
    "Lower Roman": "Mal\xe9 r\xedmske \u010d\xedslice",
    "Match case": "Rozli\u0161ova\u0165 ve\u013ek\xe9/mal\xe9 p\xedsmen\xe1",
    "Mathematical": "Matematick\xe9",
    "Media poster (Image URL)": "Obr\xe1zok m\xe9dia (URL obr\xe1zka)",
    "Media...": "M\xe9di\xe1...",
    "Medium Blue": "Stredn\xe1 modr\xe1",
    "Medium Gray": "Stredn\xe1 siv\xe1",
    "Medium Purple": "Stredn\xe1 fialov\xe1",
    "Merge cells": "Zl\xfa\u010di\u0165 bunky",
    "Middle": "Stred",
    "Midnight Blue": "Polno\u010dn\xe1 modr\xe1",
    "More...": "Viac...",
    "Name": "N\xe1zov",
    "Navy Blue": "N\xe1morn\xedcka modr\xe1",
    "New document": "Nov\xfd dokument",
    "New window": "Nov\xe9 okno",
    "Next": "Nasleduj\xface",
    "No": "Nie",
    "No alignment": "Bez zarovnania",
    "No color": "Bez farby",
    "Nonbreaking space": "Pevn\xe1 medzera",
    "None": "\u017diadne",
    "Numbered list": "\u010c\xedslovan\xfd zoznam",
    "OR": "ALEBO",
    "Objects": "Objekty",
    "Ok": "Ok",
    "Open help dialog": "Otvori\u0165 okno n\xe1povedy",
    "Open link": "Otvori\u0165 linku",
    "Open link in...": "Otvori\u0165 odkaz v...",
    "Open popup menu for split buttons": "Otvorte vyskakovacie menu pre rozdelen\xe9 tla\u010didl\xe1",
    "Orange": "Oran\u017eov\xe1",
    "Outset": "Vyst\xfapen\xe9",
    "Page break": "Zalomenie str\xe1nky",
    "Paragraph": "Odstavec",
    "Paste": "Prilepi\u0165",
    "Paste as text": "Vlo\u017ei\u0165 ako text",
    "Paste column after": "Vlo\u017ei\u0165 st\u013apec za",
    "Paste column before": "Vlo\u017ei\u0165 st\u013apec pred",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Vkladanie je v m\xf3de neform\xe1tovan\xe9ho textu. Vkladan\xfd obsah bude vlo\u017een\xfd ako neform\xe1tovan\xfd, a\u017e pok\xfdm t\xfato mo\u017enos\u0165 nevypnete.",
    "Paste or type a link": "Prilepte alebo nap\xed\u0161te odkaz",
    "Paste row after": "Prilepi\u0165 riadok za",
    "Paste row before": "Prilepi\u0165 riadok pred",
    "Paste your embed code below:": "Vlo\u017ete k\xf3d pre vlo\u017eenie ni\u017e\u0161ie:",
    "People": "\u013dudia",
    "Plugins": "Pluginy",
    "Plugins installed ({0}):": "Nain\u0161talovan\xe9 pluginy ({0}):",
    "Powered by {0}": "Pou\u017e\xedva {0}",
    "Pre": "Pre",
    "Preferences": "Preferencie",
    "Preformatted": "Predform\xe1tovan\xe9",
    "Premium plugins:": "Pr\xe9miov\xe9 pluginy:",
    "Press the Up and Down arrow keys to resize the editor.": "Ve\u013ekos\u0165 editora zmen\xedte stla\u010den\xedm kl\xe1vesov so \u0161\xedpkami Nahor a\xa0Nadol.",
    "Press the arrow keys to resize the editor.": "Ve\u013ekos\u0165 editora zmen\xedte stla\u010den\xedm kl\xe1ves so \u0161\xedpkami.",
    "Press {0} for help": "Ak potrebujete pomoc, stla\u010dte {0}",
    "Preview": "Uk\xe1\u017eka",
    "Previous": "Predch\xe1dzaj\xface",
    "Print": "Tla\u010d",
    "Print...": "Tla\u010d...",
    "Purple": "Fialov\xe1",
    "Quotations": "Kvot\xe1cie",
    "R": "\u010c",
    "Range 0 to 255": "Rozsah 0 a\u017e 255",
    "Red": "\u010cerven\xe1",
    "Red component": "\u010cerven\xe1 zlo\u017eka",
    "Redo": "Znova",
    "Remove": "Odstr\xe1ni\u0165",
    "Remove color": "Odstr\xe1ni\u0165 farbu",
    "Remove link": "Odstr\xe1ni\u0165 odkaz",
    "Replace": "Nahradi\u0165",
    "Replace all": "Nahradi\u0165 v\u0161etko",
    "Replace with": "Nahradi\u0165 \u010d\xedm",
    "Resize": "Zmeni\u0165 ve\u013ekos\u0165",
    "Restore last draft": "Obnovi\u0165 posledn\xfd koncept",
    "Reveal or hide additional toolbar items": "Odhali\u0165 alebo skry\u0165 \u010fal\u0161ie polo\u017eky panela s\xa0n\xe1strojmi",
    "Rich Text Area": "Oblas\u0165 pre text vo form\xe1te RTF",
    "Rich Text Area. Press ALT-0 for help.": "Oblas\u0165 pre text vo form\xe1te RTF. Stla\u010dte ALT-0 pre n\xe1povedu.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Oblas\u0165 pre text vo form\xe1te RTF. Stla\u010dte ALT-F9 pre zobrazenie menu. Stla\u010dte ALT-F10 pre zobrazenie panela n\xe1strojov. Stla\u010dte ALT-0 pre n\xe1povedu.",
    "Ridge": "Vyst\xfapen\xfd okraj",
    "Right": "Vpravo",
    "Right to left": "Sprava do\u013eava",
    "Row": "Riadok",
    "Row clipboard actions": "Clipboard akcie nad riadkom",
    "Row group": "Skupina riadkov",
    "Row header": "Hlavi\u010dka riadku",
    "Row properties": "Vlastnosti riadku",
    "Row type": "Typ riadku",
    "Rows": "Riadky",
    "Save": "Ulo\u017ei\u0165",
    "Save (if save plugin activated)": "Ulo\u017ei\u0165 (ak je aktivovan\xfd plugin ulo\u017eenia)",
    "Scope": "Oblas\u0165",
    "Search": "Vyh\u013eada\u0165",
    "Select all": "Ozna\u010di\u0165 v\u0161etko",
    "Select...": "Vyberte...",
    "Selection": "V\xfdber",
    "Shortcut": "Odkaz",
    "Show blocks": "Zobrazi\u0165 bloky",
    "Show caption": "Zobrazi\u0165 popis",
    "Show invisible characters": "Zobrazi\u0165 skryt\xe9 znaky",
    "Size": "Ve\u013ekos\u0165",
    "Solid": "Pln\xe1 \u010diara",
    "Source": "Zdroj",
    "Source code": "Zdrojov\xfd k\xf3d",
    "Special Character": "\u0160peci\xe1lny znak",
    "Special character...": "\u0160peci\xe1lny znak...",
    "Split cell": "Rozdeli\u0165 bunku",
    "Square": "\u0160tvorcov\xfd",
    "Start list at number": "Za\u010da\u0165 zoznam \u010d\xedslom",
    "Strikethrough": "Pre\u010diarknut\xe9",
    "Style": "\u0160t\xfdl",
    "Subscript": "Doln\xfd index",
    "Superscript": "Horn\xfd index",
    "Switch to or from fullscreen mode": "Prepn\xfa\u0165 do alebo z re\u017eimu plnej obrazovky",
    "Symbols": "Symboly",
    "System Font": "Syst\xe9mov\xe9 p\xedsmo",
    "Table": "Tabu\u013eka",
    "Table caption": "Nadpis tabu\u013eky",
    "Table properties": "Vlastnosti tabu\u013eky",
    "Table styles": "\u0160t\xfdly tabu\u013eky",
    "Template": "\u0160abl\xf3na",
    "Templates": "\u0160abl\xf3ny",
    "Text": "Text",
    "Text color": "Farba textu",
    "Text color {0}": "Farba textu {0}",
    "Text to display": "Text na zobrazenie",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL adresa, ktor\xfa ste zadali je pravdepodobne emailov\xe1 adresa. \u017del\xe1te si prida\u0165 po\u017eadovan\xfa predponu mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL adresa, ktor\xfa ste zadali je pravdepodobne extern\xfd odkaz. Chcete prida\u0165 po\u017eadovan\xfa predponu http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "URL, ktor\xfa ste zadali vyzer\xe1 ako extern\xfd odkaz. Prajete si pridat po\u017eadovan\xfa predponu https://?",
    "Title": "Nadpis",
    "To open the popup, press Shift+Enter": "Na otvorenie kontextovej ponuky stla\u010dte Shift+Enter",
    "Toggle accordion": "Prepn\xfa\u0165 rozba\u013eovaciu sekciu",
    "Tools": "N\xe1stroje",
    "Top": "Vrch",
    "Travel and Places": "Cestovanie a miesta",
    "Turquoise": "Tyrkysov\xe1",
    "Underline": "Pod\u010diarknut\xe9",
    "Undo": "Sp\xe4\u0165",
    "Upload": "Nahra\u0165",
    "Uploading image": "Nahr\xe1vam obr\xe1zok",
    "Upper Alpha": "Ve\u013ek\xe9 p\xedsmen\xe1",
    "Upper Roman": "Ve\u013ek\xe9 r\xedmske \u010d\xedslice",
    "Url": "Url adresa",
    "User Defined": "Definovan\xe9 pou\u017e\xedvate\u013eom",
    "Valid": "Platn\xe9",
    "Version": "Verzia",
    "Vertical align": "Vertik\xe1lne zarovnanie",
    "Vertical space": "Vertik\xe1lny priestor",
    "View": "Zobrazi\u0165",
    "Visual aids": "Vizu\xe1lne pom\xf4cky",
    "Warn": "Upozornenie",
    "White": "Biela",
    "Width": "\u0160\xedrka",
    "Word count": "Po\u010det slov",
    "Words": "Slov\xe1",
    "Words: {0}": "Slov\xe1: {0}",
    "Yellow": "\u017dlt\xe1",
    "Yes": "\xc1no",
    "You are using {0}": "Pou\u017e\xedvate {0}",
    "You have unsaved changes are you sure you want to navigate away?": "M\xe1te neulo\u017een\xe9 zmeny, naozaj chcete opusti\u0165 str\xe1nku?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "V\xe1\u0161 prehliada\u010d nepodporuje priamy pr\xedstup do schr\xe1nky. Pou\u017eite kl\xe1vesov\xe9 skratky Ctrl+X/C/V.",
    "alignment": "zarovnanie",
    "austral sign": "znak pre austral",
    "cedi sign": "znak pre cedi",
    "colon sign": "znak dvojbodky",
    "cruzeiro sign": "znak pre cruzeiro",
    "currency sign": "znak meny",
    "dollar sign": "znak pre dol\xe1r",
    "dong sign": "znak pre dong",
    "drachma sign": "znak pre drachmu",
    "euro-currency sign": "znak eura",
    "example": "pr\xedklad",
    "formatting": "form\xe1tovanie",
    "french franc sign": "znak pre franc\xfazsky frank",
    "german penny symbol": "znak pre nemeck\xfd pfennig",
    "guarani sign": "znak pre guarani",
    "history": "hist\xf3ria",
    "hryvnia sign": "znak pre hrivnu",
    "indentation": "odsadenie",
    "indian rupee sign": "znak pre indick\xfa rupiu",
    "kip sign": "znak pre kip",
    "lira sign": "znak pre l\xedru",
    "livre tournois sign": "znak pre livre tournois",
    "manat sign": "znak pre manat",
    "mill sign": "znak pre mill",
    "naira sign": "znak pre nairu",
    "new sheqel sign": "znak pre nov\xfd \u0161ekel",
    "nordic mark sign": "znak pre nordick\xfa marku",
    "peseta sign": "znak pre pesetu",
    "peso sign": "znak pre peso",
    "ruble sign": "znak pre rube\u013e",
    "rupee sign": "znak pre rupiu",
    "spesmilo sign": "znak pre spesmilo",
    "styles": "\u0161t\xfdly",
    "tenge sign": "znak pre tenge",
    "tugrik sign": "znak pre tugrik",
    "turkish lira sign": "znak pre tureck\xfa l\xedru",
    "won sign": "znak pre won",
    "yen character": "znak pre jen",
    "yen/yuan character variant one": "znak pre jen/j\xfcan variant jedna",
    "yuan character": "znak pre j\xfcan",
    "yuan character, in hong kong and taiwan": "znak pre j\xfcan, v Hongkongu a Taiwane",
    "{0} characters": "Znaky: {0}",
    "{0} columns, {1} rows": "{0} st\u013apcov, {1} riadkov",
    "{0} words": "{0} slov\xe1/slov"
});